export const logChangeDesign = (ecardId: string, templateId: string) => {
  window.dataLayer.push({
    event: 'change_card_design',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId || null,
    // biome-ignore lint/style/useNamingConvention: existing error
    template_id: templateId,
  });
};

export const logChangeReveal = (ecardId: string, revealId: string) => {
  window.dataLayer.push({
    event: 'change_card_reveal',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId || null,
    // biome-ignore lint/style/useNamingConvention: existing error
    reveal_id: revealId,
  });
};

export const logChangeEffect = (ecardId: string, overlayId: string) => {
  window.dataLayer.push({
    event: 'change_card_effect',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId || null,
    // biome-ignore lint/style/useNamingConvention: existing error
    overlay_id: overlayId,
  });
};

export const logDesignStepPreviewClick = (ecardId: string) => {
  window.dataLayer.push({
    event: 'card_design_step_open_preview',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId || null,
  });
};

export const logGiftCardsStepPreviewClick = (ecardId: string) => {
  window.dataLayer.push({
    event: 'card_gift_cards_step_open_preview',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId,
  });
};

export const logRecipientMessagesStepPreviewClick = (ecardId: string) => {
  window.dataLayer.push({
    event: 'card_recipient_messages_step_open_preview',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId,
  });
};

export const logAddGlobalMessage = (ecardId: string) => {
  window.dataLayer.push({
    event: 'add_global_card_message',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId,
  });
};

export const logAddCustomMessage = (ecardId: string) => {
  window.dataLayer.push({
    event: 'add_custom_card_message',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId,
  });
};

export const logSelectSendCardNow = (ecardId: string) => {
  window.dataLayer.push({
    event: 'select_send_card_now',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId,
  });
};

export const logSelectSendCardLater = (ecardId: string) => {
  window.dataLayer.push({
    event: 'select_send_card_later',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId,
  });
};

export const logReactToCard = (ecardId: string, guestId: string, reaction: string) => {
  window.dataLayer.push({
    event: 'react_to_card',
    // biome-ignore lint/style/useNamingConvention: existing error
    card_id: ecardId,
    // biome-ignore lint/style/useNamingConvention: existing error
    guest_id: guestId,
    reaction,
  });
};
